import {ajax,getRequestUrl,formatData} from "../request";

export default {
  countryAdminList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/list'), data, {
      method,
    });
  },
  countryAdminTeamSave(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/save'), data, {
      method,
    });
  },
  countryAdminTeamDel(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/delete'), data, {
      method,
    });
  },
  countryAdminTeamSalary(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/salary'), data, {
      method,
    });
  },
  countryAdminTeamRecharge(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/agent/recharge'), data, {
      method,
    });
  },
  countryAdminTeamAgentList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/agentList'), data, {
      method,
    });
  },
   countryAdminTeamKick(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/kick'), data, {
      method,
    });
  },
  countryAdminTeamSaveUser(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/save'), data, {
      method,
    });
  },
  countryAdminTeamList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/list'), data, {
      method,
    });
  },
  countryAdminInviteList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/userInvite/list'), data, {
      method,
    });
  },
   countryAdminPattyGameList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/roomParty/list'), data, {
      method,
    });
  },
 countryAdminSalaryLog(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/team/salary/list'), data, {
      method,
    });
  },
 countryAdminAppointLog(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/appointLog'), data, {
      method,
    });
  },
  countryAdminClubList(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/bindClubs/list'), data, {
      method,
    });
  },
  countryAdminClubSave(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/bindClubs/save'), data, {
      method,
    });
  },
  countryAdminClubDelete(data, method) {
    return ajax('post', getRequestUrl('/countryAdmin/bindClubs/delete'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/countryAdmin.js